// No deep linking for web at the moment
export const useDeepLinkURL = () => {};
